import React, { useEffect, useState, useRef } from 'react';
import client from '../api/client';

const DEFAULT_INTERVAL_MS = 30 * 60 * 1000; // 30 min fallback

export default function VersionBanner() {
  const [show, setShow] = useState(false);
  const initialVersion = useRef(null);
  const timerRef       = useRef(null);

  useEffect(() => {
    const check = async () => {
      try {
        // _t cache-buster prevents the browser returning a stale cached response
        const r = await client.get('/security/version', { params: { _t: Date.now() } });
        const v = r.data.version;
        if (initialVersion.current === null) {
          initialVersion.current = v;
        } else if (v !== initialVersion.current) {
          setShow(true);
        }
      } catch { /* ignore network errors */ }
    };

    const startPolling = (intervalMs) => {
      check();
      timerRef.current = setInterval(check, intervalMs);
    };

    client.get('/security/poll-config', { params: { _t: Date.now() } })
      .then(r => startPolling((r.data.interval_minutes || 30) * 60 * 1000))
      .catch(() => startPolling(DEFAULT_INTERVAL_MS));

    return () => clearInterval(timerRef.current);
  }, []);

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      backgroundColor: '#0d6efd', color: '#fff',
      padding: '10px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      fontSize: '14px', boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    }}>
      <div>
        <i className="bi bi-arrow-repeat mr-2" />
        <strong>New version deployed.</strong> Refresh the page to get the latest updates.
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '4px 16px', backgroundColor: '#fff', color: '#0d6efd',
            border: 'none', borderRadius: '4px', fontWeight: 600, cursor: 'pointer',
            fontSize: '13px',
          }}
        >
          Refresh Now
        </button>
        <button
          onClick={() => setShow(false)}
          style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: '18px' }}
        >
          ×
        </button>
      </div>
    </div>
  );
}
